import _ from 'lodash'

export default class Generic {
  constructor(attributes) {
    this._attributes = attributes;

    _.forEach(_.keys(attributes), (name) => {
      Object.defineProperty(this, name, { value: attributes[name] })
    })
  }

  translates(hash) {
    return hash[I18n.locale] || hash[I18n.defaultLocale] || _.head(_.values(hash))
  }
}
